module.exports = __webpack_public_path__ + "img/pr-10.5c271c48.png";